type Props = {
  src: string
  alt: string
  size?: 'sm' | 'md' | 'lg'
  glow?: boolean
}

const sizes = {
  sm: 'max-w-[220px] sm:max-w-[240px]',
  md: 'max-w-[260px] sm:max-w-[280px]',
  lg: 'max-w-[280px] sm:max-w-[320px]',
}

/**
 * PhoneFrame — a realistic iPhone 15 Pro device mockup (titanium frame + true
 * screen radius) wrapping a REAL app screenshot. No Dynamic Island overlay:
 * the screenshots already include the app's own status bar, so an overlay
 * would cover the top of the captured screen.
 */
export function PhoneFrame({ src, alt, size = 'md', glow = false }: Props) {
  return (
    <div className={`relative mx-auto w-full ${sizes[size]}`}>
      {glow && (
        <div
          aria-hidden
          className="pointer-events-none absolute -inset-10 -z-10 rounded-[60px] bg-[radial-gradient(50%_50%_at_50%_40%,rgba(0,82,204,0.22),rgba(88,86,214,0.12),transparent_75%)] blur-3xl"
        />
      )}
      <div className="relative rounded-[3rem] bg-gradient-to-b from-[#3a3a3c] via-[#1d1d1f] to-[#3a3a3c] p-[3px] shadow-[0_24px_60px_-18px_rgba(15,23,42,0.5)]">
        <div className="rounded-[2.9rem] bg-black p-[8px]">
          <div className="overflow-hidden rounded-[2.4rem] bg-[var(--color-bg)]">
            <img src={src} alt={alt} loading="lazy" decoding="async" className="block h-auto w-full" />
          </div>
        </div>
      </div>
    </div>
  )
}
